module.exports = __webpack_public_path__ + "static/media/ya.020348b9.png";